import type { ParticipantEditFields } from '../../selectors'
import { ParticipantEditAddressSection } from './ParticipantEditAddressSection'
import { ParticipantEditContactSection } from './ParticipantEditContactSection'
import { ParticipantEditPersonalSection } from './ParticipantEditPersonalSection'

interface ParticipantEditSectionsProps {
  fields: ParticipantEditFields
}

export function ParticipantEditSections({ fields }: ParticipantEditSectionsProps) {
  const {
    title,
    gender,
    firstName,
    lastName,
    dateOfBirth,
    email,
    street,
    houseNumber,
    houseNumberAddition,
    postalCode,
    city,
    countryCode,
    mobilePhoneNumbers,
    emergencyPhoneNumbers,
  } = fields

  return (
    <>
      <ParticipantEditPersonalSection fields={{ title, gender, firstName, lastName, dateOfBirth }} />
      <ParticipantEditAddressSection fields={{ street, houseNumber, houseNumberAddition, postalCode, city, countryCode }} />
      <ParticipantEditContactSection fields={{ email, mobilePhoneNumbers, emergencyPhoneNumbers }} />
    </>
  )
}
